<div class="dialog">
    <div class="dialog-header">
        <h2>{{ 'shared.dialog.password.heading'  | translate }}</h2>
        <a class="dialog-close" (click)="onCancel()">&times;</a>
    </div>
    <div class="dialog-body">
        <app-loading *ngIf="loading" height="123px"></app-loading>

        <form *ngIf="!loading">
            <div class="alert alert-error" *ngIf="error">
                {{ 'shared.dialog.password.error' | translate }}
            </div>

            <div class="form-row form-required">
                <label>{{ 'shared.label.password' | translate }}</label>
                <input type="password" required name="password" autocomplete="double-password" [(ngModel)]="model.password">
            </div>

            <div class="buttons buttons-flex">
                <a class="button button-basic-primary" (click)="onCancel()">{{ 'shared.button.cancel' | translate }}</a>
                <button class="button button-primary" (click)="onConfirm()">{{ 'shared.button.confirm' | translate }}</button>
            </div>
        </form>
    </div>
</div>
